import 'babel-polyfill';
import React, { Component } from 'react';
import { Admin, Delete, Resource } from 'admin-on-rest';


import './App.css';

import authClient from './authClient';
import sagas from './sagas';
import themeReducer from './themeReducer';
import Login from './Login';
//import MyLayout from './Layout';
import MyLayout from './MyNewLayout';
import Menu from './Menu';

import translations from './i18n';

import { Dashboard } from './dashboard';
import customRoutes from './routes';
//import translations from './translations';

import { VisitorList, VisitorEdit, VisitorDelete, VisitorIcon } from './visitors';
import { CommandList, CommandEdit, CommandIcon } from './commands';
import { ProductList, ProductEdit, ProductIcon } from './products';
import { CategoryList, CategoryEdit, CategoryIcon } from './categories';
import { ReviewList, ReviewEdit, ReviewIcon } from './reviews';



import { AggregatesList } from './components/Aggregates/aggregates';
import { ZicuyimAggregatesList } from './components/ZicuyimAggregates/aggregates';
import { HafkadotAggregatesList } from './components/HafkadotAggregates/aggregates';

import { DuplicateList } from './components/RiskManagement/DuplicateCards/duplicate';
import { duplicateOneMonthList } from './components/RiskManagement/DuplicateCards/duplicateOneMonth';
import { duplicateHiyuvimList } from './components/RiskManagement/DuplicateCards/duplicateHiyuvim';

import { negativeTurnoverList } from './components/RiskManagement/negativeTurnover/negativeTurnover';

import { ZicuNoMakorList } from './components/RiskManagement/ZicuNoMakor/ZicuNoMakor';
import { RisksList,RisksShow } from './components/RiskManagement/Risks/risks';



import { BitulimList ,BitulimShow} from './components/Bitulim/bitulim';

import { TransactionList , TransactionShow} from './components/Transactions/transactions';
import { PlanList , PlanShow,PlanEdit} from './components/Plans/plans';
import { FraudList , FraudShow} from './components/Fraud/frauds';
import { FraudAlertsList } from './components/Fraud/fraudsAlerts';


import { CHBList , CHBShow} from './components/CHB/chb';
import { CHBAlertsList } from './components/CHB/chbAlerts';


import { BankList , BankShow,BankEdit,BankCreate} from './components/Banks/banks';
import { AgentList , AgentShow,AgentEdit,AgentCreate} from './components/Agents/agents';
import { HafkadotList , HafkadotShow} from './components/Hafkadot/hafkadot';
import { ZikuyimList , ZikuyimShow} from './components/Zikuyim/zikuyim';
import { ZikuyimMonthList , ZikuyimMonthShow} from './components/ZikuyimMonth/zikuyimMonth';


import { HafkadotMonthList , HafkadotMonthShow} from './components/Hafkadot/hafkadot_month';


import {HiyuvimList , HiyuvimShow} from './components/Hiyuvim/hiyuvim';
import { HafkadotRicuzMonthList , HafkadotRicuzMonthShow} from './components/Hafkadot/hafkadot_ricuz_month';
import { HafkadotRicuzYomiList , HafkadotRicuzYomiShow} from './components/Hafkadot/hafkadot_ricuz_yomi';
import { TerminalTypesList , TerminalTypesShow,TerminalTypesEdit,TerminalTypesCreate} from './components/TerminalTypes/terminaltypes';
import { TerminalList , TerminalShow,TerminalEdit,TerminalCreate} from './components/Terminal/terminal';

import { DapeZahavList ,DapeZahavShow,DapeZahavEdit,DapeZahavCreate} from './components/DapeZahav/dapezahav';


import { ProviderNumberList , ProviderNumberShow,ProviderNumberEdit,ProviderNumberCreate} from './components/ProviderNumber/providernumber';


import { ZicuidateplansList , ZicuidateplansShow,ZicuidateplansEdit,ZicuidateplansCreate} from './components/Zicuidateplans/zicuidateplan';
import { ProfileList , ProfileShow} from './components/Profile/profile';
import { UserList , UserShow,UserEdit,UserCreate} from './components/User/user';

import restClient from './restClient';


//import createHistory from 'history/createBrowserHistory';
//const history = createHistory();








//import restClientFactory from './rest/restClient';

//const restClient1 = restClientFactory('http://api-dev.slika.org.il/api', () => window.localStorage.getItem('token'),'');

//import fakeRestServer from './restServer';

class App extends Component {
  
 
    render() {
        return (
            <Admin
                title="איגוד הסליקה הישראלי - דף חשבון"
                restClient={restClient}
                customReducers={{ theme: themeReducer }}
                customSagas={sagas}
                customRoutes={customRoutes}
                authClient={authClient}
                dashboard={Dashboard}
                loginPage={Login}
                appLayout={MyLayout}
//history={history}
              
                messages={translations}
                locale={'he'} 
            >
            <Resource name="hafkadot" list={HafkadotList} show={HafkadotShow} />
            <Resource name="zikuyim" list={ZikuyimList} show={ZikuyimShow} />
            <Resource name="zikuyim_month" list={ZikuyimMonthList} show={ZikuyimMonthShow} />
<Resource name="customers" list={UserList} show={UserShow}   edit={UserEdit}  create={UserCreate} />
<Resource name="agents" list={AgentList} show={AgentShow} edit={AgentEdit} create={AgentCreate}/>
              <Resource name="providernumbers" list={ProviderNumberList} show={ProviderNumberShow} edit={ProviderNumberEdit} create={ProviderNumberCreate}/>

              <Resource name="tagmul" list={TerminalList} show={TerminalShow} edit={TerminalEdit} create={TerminalCreate}/>

                <Resource name="plans" list={PlanList} show={PlanShow} edit={PlanEdit} />
               <Resource name="zicuidateplans" list={ZicuidateplansList} show={ZicuidateplansShow} edit={ZicuidateplansEdit} create={ZicuidateplansCreate}/>
<Resource name="terminaltypes" list={TerminalTypesList} show={TerminalTypesShow} edit={TerminalTypesEdit} create={TerminalTypesCreate}/>

                
                <Resource name="banks" list={BankList} show={BankShow} edit={BankEdit} create={BankCreate}/>


<Resource name="hiyuvim" list={HiyuvimList} show={HiyuvimShow} />
<Resource name="hafkadot_month" list={HafkadotMonthList} show={HafkadotMonthShow} />
<Resource name="hafkadot_ricuz_month" list={HafkadotRicuzMonthList} show={HafkadotRicuzMonthShow} />
<Resource name="hafkadot_ricuz_yomi" list={HafkadotRicuzYomiList} show={HafkadotRicuzYomiShow} />
<Resource name="dapezahav" list={DapeZahavList} show={DapeZahavShow} edit={DapeZahavEdit} create={DapeZahavCreate}/>
<Resource name="aggregates" list={AggregatesList}/>
<Resource name="zicuyim_aggregates" list={ZicuyimAggregatesList}/>
<Resource name="hafkadot_aggregates" list={HafkadotAggregatesList}/>

<Resource name="bitulim" list={BitulimList} show={BitulimShow}  />


<Resource name="chb/alerts" list={CHBAlertsList}  />
<Resource name="chb" list={CHBList} show={CHBShow}  />

<Resource name="frauds/alerts" list={FraudAlertsList}  />
<Resource name="frauds" list={FraudList} show={FraudShow}  />



<Resource name="Risks/duplicateCard" list={DuplicateList}/>
<Resource name="Risks/duplicateOneMonth" list={duplicateOneMonthList}/>
<Resource name="Risks/duplicateHiyuvim" list={duplicateHiyuvimList}/>
<Resource name="Risks/negativeTurnover" list={negativeTurnoverList}/>


<Resource name="Risks/ZicuNoMakor" list={ZicuNoMakorList}/>


<Resource name="Risks/risks" list={RisksList} show={RisksShow}/>

        
            </Admin>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js